document.addEventListener("DOMContentLoaded", function(event) {
  // function handle(delta) {
  //     var time = 900;
  //     var distance = 80;
  //
  //     $('html, body').stop().animate({
  //         scrollTop: $(window).scrollTop() - (distance * delta)
  //     }, time );
  // }
  // function wheel(event) {
  //   if( $(window).scrollTop() <=30 ) {
  //     var delta = 0;
  //     if (event.wheelDelta) {(delta = event.wheelDelta / 400);}
  //     else if (event.detail) {(delta = -event.detail / 30);}
  //
  //     handle(delta);
  //     if (event.preventDefault) {(event.preventDefault());}
  //     event.returnValue = false;
  //   }
  //
  // }



// if ($("body").hasClass("single-programmes")){
//
//   // if (window.addEventListener) {window.addEventListener('DOMMouseScroll', wheel, false);}
//     // window.onmousewheel = document.onmousewheel = wheel;
//
//   $(window).scroll(function (event) {
//       var scroll = $(window).scrollTop();
//       // Do something
//       if (scroll <= 30){
//         handle(0);
//         };
//
//   });
//
// };



  if ($(window).width() >= 992) {
    var height = $('.up-prog__avantages ul').height();
// console.log(height);

    $('.up-prog__avantages ul').css('height', height*0.6);
  }

  $('.single-programmes').addClass('intro-effect-jam3');

  $('.up-prog__resume--tab').append('<div class="up-prog__resume--tab_close  fas  fa-times" />');
  $('.up-prog__resume--tab').click(function() {

    if ($('.up-prog__resume--content').is(':visible')) {
      $('.up-prog__resume--content').hide(150, function() {
          $('.up-prog__resume--tab_close')
            .removeClass('fa-times')
            .addClass('fa-angle-up');
      });
    } else {
      $('.up-prog__resume--content').show(150, function() {
          $('.up-prog__resume--tab_close')
            .removeClass('fa-angle-up')
            .addClass('fa-times');
      });
    }
  });





// SLIDER
  var imgArray = $('.up-prog__cover--bg-img img');
  var imgNbr = imgArray.length - 1;
  // var firstImg = $(imgArray[0]);
  // var lastImg = $(imgArray[imgNbr]);
// console.log(lastImg);
  var sliderIndex = 0;

  $(imgArray[sliderIndex]).show();

  function slider(newIndex) {
    $(imgArray[sliderIndex]).fadeOut(500);
    $(imgArray[newIndex]).fadeIn(500);
    sliderIndex = newIndex;
  }

  $('.up-prog__slidernav--prev').click(function() {
    if (sliderIndex == 0) {
      slider(imgNbr);
    } else {
      slider(sliderIndex - 1);
    }
  });

  $( ".up-prog__cover--container" ).on( "swipeleft", function( event ) {
        $('.up-prog__slidernav--prev').trigger("click");
        // console.log("prev");

    });

// $(".up-prog__cover--container" ).on('click', function() {
//      console.log("test");
// });

  $('.up-prog__slidernav--next').click(function() {
    if (sliderIndex == imgNbr) {
      slider(0);
    } else {
      slider(sliderIndex + 1);
    }
  });

  $( ".up-prog__cover--container" ).on( "swiperight", function( event ) {
        $('.up-prog__slidernav--next').trigger("click");
        // console.log("next");

    });


$("button.trigger").click(function() {
    if ($(window).width() > 500) {
      $('html,body').animate({scrollTop: 10},'slow');
    } else {
      $('html,body').animate({scrollTop: 440},'slow');
    }
});

$(window).bind('scroll', function () {
		    if ($(window).scrollTop() <= 0) {
		        $('body.single-programmes').removeClass('modify');
            $('.single-programmes .navbar-header img').attr('src', '/app/themes/uptown/assets/images/logo_blanc.png');


              $('.up-prog__resume--tab, .up-prog__slidernav').fadeIn(300);
              $('.single-programmes .up-prog__resume--content').hide();
              // $('.up-prog__resume--tab').removeClass('hide');

            $('.up-prog__resume--tab_close')
              .removeClass('fa-times')
              .addClass('fa-angle-up');


		    }else{
          $('body.single-programmes').addClass('modify');
          $('.single-programmes .navbar-header img').attr('src', '/app/themes/uptown/assets/images/logo.png');
          $('.up-prog__resume--tab').show();
          if ($(window).width() > 500) {
            $('.up-prog__slidernav').fadeOut(100);
            $('.single-programmes .up-prog__resume--content').show();
            // $('.up-prog__resume--tab').addClass('hide');
            $('.up-prog__resume--tab_close')
              .removeClass('fa-angle-up')
              .addClass('fa-times');
          }


        }

	});

// Animation cover
(function() {

				// detect if IE : from http://stackoverflow.com/a/16657946
				// var ie = (function(){
				// 	var undef,rv = -1; // Return value assumes failure.
				// 	var ua = window.navigator.userAgent;
				// 	var msie = ua.indexOf('MSIE ');
				// 	var trident = ua.indexOf('Trident/');
        //
				// 	if (msie > 0) {
				// 		// IE 10 or older => return version number
				// 		rv = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
				// 	} else if (trident > 0) {
				// 		// IE 11 (or newer) => return version number
				// 		var rvNum = ua.indexOf('rv:');
				// 		rv = parseInt(ua.substring(rvNum + 3, ua.indexOf('.', rvNum)), 10);
				// 	}
        //
				// 	return ((rv > -1) ? rv : undef);
				// }());


				// disable/enable scroll (mousewheel and keys) from http://stackoverflow.com/a/4770179
				// left: 37, up: 38, right: 39, down: 40,
				// spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
				// var keys = [32, 37, 38, 39, 40], wheelIter = 0;
        //
				// function preventDefault(e) {
				// 	e = e || window.event;
				// 	if (e.preventDefault)
				// 	e.preventDefault();
				// 	e.returnValue = false;
				// }

				// function keydown(e) {
				// 	for (var i = keys.length; i--;) {
				// 		if (e.keyCode === keys[i]) {
				// 			preventDefault(e);
				// 			return;
				// 		}
				// 	}
				// }

				// function touchmove(e) {
				// 	preventDefault(e);
				// }

				// function wheel(e) {
				// 	// for IE
				// 	//if( ie ) {
				// 		//preventDefault(e);
				// 	//}
				// }

				// function disable_scroll() {
				// 	window.onmousewheel = document.onmousewheel = wheel;
				// 	document.onkeydown = keydown;
				// 	document.body.ontouchmove = touchmove;
				// }

				// function enable_scroll() {
				// 	window.onmousewheel = document.onmousewheel = document.onkeydown = document.body.ontouchmove = null;
				// }

				// var docElem = window.document.documentElement,
				// 	scrollVal,
				// 	isRevealed,
				// 	noscroll,
				// 	isAnimating,
				// 	container = document.getElementsByClassName( 'single-programmes' )[0],
				// 	trigger = container.querySelector( 'button.trigger' );

				// function scrollY() {
				// 	return window.pageYOffset || docElem.scrollTop;
				// }

				// function scrollPage() {
				// 	scrollVal = scrollY();
        //
				// 	if( noscroll && !ie ) {
				// 		if( scrollVal < 0 ) return false;
				// 		// keep it that way
				// 		window.scrollTo( 0, 0 );
				// 	}
        //
				// 	if( classie.has( container, 'notrans' ) ) {
				// 		classie.remove( container, 'notrans' );
				// 		return false;
				// 	}
        //
				// 	if( isAnimating ) {
				// 		return false;
				// 	}
        //
				// 	if( scrollVal <= 0 && isRevealed ) {
				// 		toggle(0);
				// 	}
				// 	else if( scrollVal > 0 && !isRevealed ){
				// 		toggle(1);
				// 	}
				// }

				// function toggle( reveal ) {
				// 	isAnimating = true;
        //
				// 	if( reveal ) {
				// 		// classie.add( container, 'modify' );
        //     $('.navbar-header img').attr('src', '/app/themes/uptown/assets/images/logo.png');
        //     $('.up-prog__resume--tab, .up-prog__slidernav').fadeOut(100);
        //     $('.up-prog__resume--content').show();
        //     $('.up-prog__resume--tab_close')
        //       .removeClass('fa-angle-up')
        //       .addClass('fa-times');
				// 	}
				// 	else {
				// 		noscroll = true;
				// 		// disable_scroll();
				// 		// classie.remove( container, 'modify' );
        //     $('.navbar-header img').attr('src', '/app/themes/uptown/assets/images/logo_blanc.png');
        //     $('.up-prog__resume--tab, .up-prog__slidernav').fadeIn(300);
        //     $('.up-prog__resume--content').hide();
        //     $('.up-prog__resume--tab_close')
        //       .removeClass('fa-times')
        //       .addClass('fa-angle-up');
				// 	}

					// simulating the end of the transition:
				// 	setTimeout( function() {
				// 		isRevealed = !isRevealed;
				// 		isAnimating = false;
				// 		if( reveal ) {
				// 			noscroll = false;
				// 			enable_scroll();
				// 		}
				// 	}, 600 );
				// }

				// refreshing the page...
				// var pageScroll = scrollY();
				// noscroll = pageScroll === 0;

				// disable_scroll();

				// if( pageScroll ) {
				// 	isRevealed = true;
				// 	classie.add( container, 'notrans' );
					// classie.add( container, 'modify' );
				// }

				// window.addEventListener( 'scroll', scrollPage );
				// trigger.addEventListener( 'click', function() { toggle( 'reveal' ); } );
			})();
});
